(function ($, Drupal) {
  Drupal.showModal = function({title = '', message = '', className = '', size = 'large'} = params) {
		bootbox.dialog({
			className: `mp-modal ${className}`,
			message,
			title,
			size: size,
			animate: false,
			onEscape: true,
			backdrop: true,
			closeButton: false,
			centerVertical: true,
			onShown: function(e) {
				$closeButton = $(`
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				`)
				$(this)
					.find('.modal-content')
					.prepend($closeButton)
				;

				Drupal.attachBehaviors();
			}
		});
	}
})(jQuery, Drupal);
